var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLangArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2697 1.30094L7.30094 7.01969C7.11344 7.17594 6.92594 7.23844 6.76969 7.23844C6.58219 7.23844 6.39469 7.17594 6.23844 7.05094L0.238436 1.30094C-0.0740645 1.01969 -0.0740645 0.519686 0.207186 0.238436C0.488436 -0.0740645 0.988436 -0.0740645 1.26969 0.207186L6.76969 5.45719L12.2384 0.207186C12.5197 -0.0740645 13.0197 -0.0740645 13.3009 0.238436C13.5822 0.519686 13.5822 1.01969 13.2697 1.30094Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangArrow);
export default __webpack_public_path__ + "static/media/lang-arrow.af6d92816b3231ffd3e3dc89a7502a07.svg";
export { ForwardRef as ReactComponent };